export type ReservationStatus = "Pending" | "Confirmed" | "Cancelled" | "Rejected" | "Completed" | string;
export type ReservationSource = "CustomerForm" | "Phone" | "Panel" | string;

export interface IReservation {
  id: string;
  restourantId: string;
  startsAtUtc: string;
  endsAtUtc: string;
  partySize: number;
  status: ReservationStatus;
  source: ReservationSource;
  contactName: string;
  contactPhone: string;
  note: string;
  createdAtUtc: string;
  cancellationReason: string;
}

export interface IRestaurantTable {
  id: string;
  restourantId: string;
  tableNumber: number;
  capacity: number;
  minCapacity: number;
  label: string;
  isEnabled: boolean;
}

export interface IRestaurantTableCreate {
  restourantId: string;
  tableNumber: number;
  capacity: number;
  /** Opsiyonel (1–100, kapasiteyi aşamaz) */
  minCapacity?: number;
  /** Opsiyonel (en çok 100 karakter) */
  label?: string;
}

export interface IRestaurantTableUpdate {
  id: string;
  tableNumber: number;
  capacity: number;
  minCapacity: number;
  label: string;
  isEnabled: boolean;
}

export interface IReservationConfirm {
  id: string;
  tableId: string;
  durationMinutes: number;
}

/** Personelin telefonla/kapıda aldığı rezervasyon — doğrudan Confirmed doğar, OTP yok. */
export interface ICreateStaffReservation {
  restourantId: string;
  tableId: string;
  startsAtUtc: string;
  partySize: number;
  contactName: string;
  contactPhone: string;
  note?: string;
  /** Boş bırakılırsa restoranın varsayılan süresi kullanılır. */
  durationMinutes?: number;
  source: ReservationSource;
}

export type TableUnavailableReason = "RestaurantClosed" | "Booked" | "TooSmall" | "TooLarge" | string;

export interface ITableAvailabilityBooking {
  reservationId: string;
  startsAtUtc: string;
  endsAtUtc: string;
}

export interface ITableAvailability {
  id: string;
  tableNumber: number;
  label: string;
  capacity: number;
  minCapacity: number;
  isAvailable: boolean;
  unavailableReason?: TableUnavailableReason;
  bookings: ITableAvailabilityBooking[];
}

export interface IReservationScheduleItem {
  id: string;
  restourantId: string;
  tableId: string;
  tableNumber: number;
  tableLabel: string;
  startsAtUtc: string;
  endsAtUtc: string;
  partySize: number;
  status: ReservationStatus;
  source: ReservationSource;
  contactName: string;
  contactPhone: string;
  note: string;
  createdAtUtc: string;
  confirmedAtUtc: string;
  cancellationReason: string;
}

export interface IReservationSettings {
  restourantId: string;
  isEnabled: boolean;
  defaultDurationMinutes: number;
  bufferMinutes: number;
  minLeadTimeMinutes: number;
  maxAdvanceDays: number;
  maxPartySize: number;
  isConfigured: boolean;
}

export interface IReservationSettingsUpdate {
  restourantId: string;
  isEnabled: boolean;
  defaultDurationMinutes: number;
  bufferMinutes: number;
  minLeadTimeMinutes: number;
  maxAdvanceDays: number;
  maxPartySize: number;
}

export type ReservationCancellationReason =
  | "PlansChanged" | "TimeNotSuitable" | "FoundAnotherPlace" | "Other"
  | "NoSuitableTable" | "RestaurantClosed" | "OverBooked" | "RestaurantOther";

export interface IChangeReservationStatus {
  id: string;
  status: "Rejected" | "Cancelled";
  cancellationReason: ReservationCancellationReason;
  cancellationNote?: string;
}

// Reddetme (Rejected) yalnızca restoran tarafı gerekçe kabul eder.
export const RESTAURANT_CANCELLATION_REASONS: { value: ReservationCancellationReason; label: string }[] = [
  { value: "NoSuitableTable", label: "Uygun masa yok" },
  { value: "RestaurantClosed", label: "Restoran o saatte kapalı" },
  { value: "OverBooked", label: "O akşam dolu" },
  { value: "RestaurantOther", label: "Diğer" },
];

// İptal (Cancelled) hem misafir hem restoran gerekçesini kabul eder — personel misafir adına da iptal edebilir.
export const GUEST_CANCELLATION_REASONS: { value: ReservationCancellationReason; label: string }[] = [
  { value: "PlansChanged", label: "Planları değişti" },
  { value: "TimeNotSuitable", label: "Saat uygun değil" },
  { value: "FoundAnotherPlace", label: "Başka yer buldu" },
  { value: "Other", label: "Diğer" },
];
